module.exports = __webpack_public_path__ + "img/empty_person.0ddfe3d1.png";